import React from 'react';

import ShowMetrics, { TYPE_METRICS } from '../../helpers/ShowMetrics';

function MasterAgentMetrics({ url }: { url: string }) {
    return (
        <div className="row metrics">
            <ShowMetrics
                url={url}
                path="master_agent_resellers_sale_sum"
                label="Resellers Sale Sum"
                typeMetrics={TYPE_METRICS.VALUE_METRIC}
            />
            <ShowMetrics
                url={url}
                path="master_agent_resellers_revenue"
                label="Resellers Revenue"
                typeMetrics={TYPE_METRICS.VALUE_METRIC}
            />
            <ShowMetrics
                url={url}
                path="master_agent_super_agents_revenue"
                label="Super Agents Revenue"
                typeMetrics={TYPE_METRICS.VALUE_METRIC}
            />
            <ShowMetrics
                url={url}
                path="master_agent_revenue"
                label="Master Agent Revenue"
                typeMetrics={TYPE_METRICS.VALUE_METRIC}
            />
            <ShowMetrics
                url={url}
                path="master_agent_tickets_winnings"
                label="Winnings"
                typeMetrics={TYPE_METRICS.VALUE_METRIC}
            />
        </div>
    );
}

export default MasterAgentMetrics;
